const BrasselerColors = {
    white: "#ffffff",
    white1: "#eff4ff",
    white2: "#f1f1f1",
    white3: "#f5f5f5",
    white4: "#f9f9f9",
    white5: "#f4fff2",
    white6: "#f3f3f3",
    white7: "#fcf4f2",
    white8: "#E9EDF8",
    white9: "#fafafa",
    white10: "#f6f6f6",
    black: "#000000",
    black2: "#333",
    black3: "#222",
    blackWithOpacity: "rgba(0, 0, 0, 0.3)",
    grayWithOpacity: "rgba(85, 86, 90, 0.3)",
    boxShadow: "rgba(25,25,25,.2)",
    inputBoxShadow: "rgba(44,98,255,.1)",
    primary: "#00194A",
    primaryShadow: "rgba(0,25,74,0.6)",
    secondary: "#00359C",
    primaryRed: "#c3002f",
    grayBorder: "#ccccce",
    grayBorder1: "#e0e7ea",
    inputBorder: "#afb8c7",
    borderWithOpacity: "rgba(255,255,255,.3)",
    secondaryBorderWithOpacity: "rgba(255,255,255,.2)",
    grayBorderWithOpacity: "rgba(0, 25, 74, 0.2)",
    lightBorderWithOpacity: "rgba(0, 25, 74, 0.1)",
    primaryColorOpacity4: "rgba(0, 25, 74, 0.4)",
    searchBorderWithOpacity: "rgba(175, 183, 198, 0.6)",
    darkBlue1: "#22538f",
    darkGray1: "#808ca5",
    blue1: "#4e6a9f",
    blue2: "#2248b5",
    blue3: "#4c9fdc",
    blue4: "#003790",
    blue5: "#0033a0",
    blue6: "#1e90ff",
    blue7: "#0075FF",
    blue8: "#4947b1",
    blue9: "#007095",
    blue10: "#0832a2",
    gray1: "#636363",
    gray2: "#efefef",
    gray3: "#EEEEF0",
    gray4: "#ccd1db",
    gray5: "#aeb7c6",
    gray6: "#cccccc",
    pgray7: "#7b89a4",
    pgray8: "#727e96",
    pgray9: "#708090",
    pgray10: "#55565a",
    pgray11: "#dddddd",
    pgray12: "#d3d3d3",
    pgray15: "#e5e5e5",
    pgray16: "#aaa",
     pgray17:"#D6D5D3",
    gray7: "#dddddd",
    gray8: "#99a3b7",
    gray9: "#55565a",
    gray10: "#767679",
    gray11: "#888888",
    gray12: "#252525",
    gray14: "#7d7d7d",
    gray15: "#999999",
    gray16: "#dcdcdc",
    gray17: "#e0e0e0",
    gray18: "#d4d4d3",
    gray19: "#D6D6D6",
    gray20: "#ececec",
    gray21: "#eeeef0",
    gray22: "#cacacc",
    gray23: "#8a8a8a",
    gray24: "#e6e6e6",
    gray25: "#d6d9df",
    gray26: "#6b7995",
    gray27: "#aeaeae",
    gray28: "#dedede",
    gray29: "#bcbcbc",
    gray30: "#f2f2f2",
    gray31: "#e2e2e2",
    gray32:"#bbb",
    poError: "#730022",
    poBg: "#fff5f8",
    green: "#7eb13c",
    green1: "#48ca33",
    green2: "#149000",
    green3: "#0d5c00",
    green4: "#77be43",
    green5: "#3c763d",
    green6: "#dff0d8",
    silver: "#b9b8ff",
    redColor: "#c60f13",
    red1:"#C51F3B",
    pink: "#f9c9bf",
    outlineBlue: "#09f",
};

export default BrasselerColors;
